// extracted by mini-css-extract-plugin
export var _spacer = "_spacer__VBAN";
export var active = "active__XynR";
export var big = "big__LATz";
export var claims = "claims__rQV3";
export var claimsCount = "claims-count__h9Ef";
export var claims__empty = "claims__empty__Bq2v";
export var currency = "currency__gWO6";
export var fontContainer = "font-container__CiAt";
export var linkLikeBlock = "link-like-block__XITl";
export var red = "red__yXYT";
export var redBlock = "red-block__pOuI";
export var sumValue = "sum-value__OxIu";